import React from 'react';
import { Download, CheckCircle, XCircle, AlertTriangle, Clock } from 'lucide-react';

const ExportStatusBadge = ({ status, count = 0, onClick }) => {
    const getStatusConfig = () => {
        switch (status) {
            case 'pending':
                return {
                    icon: Clock,
                    className: 'bg-yellow-900/30 text-yellow-400',
                    label: 'Export Pending'
                };
            case 'in_progress':
                return {
                    icon: Download,
                    className: 'bg-blue-900/30 text-blue-400 animate-pulse',
                    label: 'Exporting...'
                };
            case 'completed':
                return {
                    icon: CheckCircle,
                    className: 'bg-green-900/30 text-green-400',
                    label: 'Exported'
                };
            case 'failed':
                return {
                    icon: XCircle,
                    className: 'bg-red-900/30 text-red-400',
                    label: 'Export Failed'
                };
            case 'partial':
                return {
                    icon: AlertTriangle,
                    className: 'bg-orange-900/30 text-orange-400',
                    label: 'Partial'
                };
            default:
                return {
                    icon: Download,
                    className: 'bg-gray-700 text-gray-400',
                    label: 'Not Exported'
                };
        }
    };

    const config = getStatusConfig();
    const Icon = config.icon;

    return (
        <button
            onClick={onClick}
            disabled={!onClick}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${config.className} ${onClick ? 'cursor-pointer hover:opacity-80' : 'cursor-default'}`}
            title={config.label}
        >
            <Icon size={14} />
            <span>{config.label}</span>
            {count > 0 && (
                <span className="ml-1 bg-black/20 px-1.5 py-0.5 rounded-full text-[10px]">
                    {count}
                </span>
            )}
        </button>
    );
};

// Helper to determine overall status from multiple attempts
export const getOverallExportStatus = (attempts) => {
    if (!attempts || attempts.length === 0) return null;

    const pending = attempts.filter(a => a.status === 'pending').length;
    const inProgress = attempts.filter(a => a.status === 'in_progress').length;
    const failed = attempts.filter(a => a.status === 'failed').length;
    const completed = attempts.filter(a => a.status === 'completed').length;

    if (inProgress > 0) return 'in_progress';
    if (pending > 0) return 'pending';
    if (failed > 0 && completed === 0) return 'failed';
    if (failed > 0 && completed > 0) return 'partial';
    if (completed > 0) return 'completed';

    return null;
};

export default ExportStatusBadge;
